var exports = {
  "h": "x43cbe9c2--95557f--tooltip-trigger",
};

module.exports = exports;
